import BitbucketBackend from './implementation';
import API from './API';
import AuthenticationPage from './AuthenticationPage';

export const DecapCmsBackendBitbucket = {
  BitbucketBackend,
  API,
  AuthenticationPage,
};
export { BitbucketBackend, API, AuthenticationPage };
